
export enum Status {
  STATUS_PUBLISH = 'publish',
  STATUS_DRAFT = 'draft',
  STATUS_PRIVATE = 'private',
}
